export default {
  geolocation: {
    lat: '59.3293',
    lng: '18.0686',
    label: '100 00 Stockholm',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
